import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import DialogContentText from '@mui/material/DialogContentText';
import MaterialTextField from '@mui/material/TextField';
import ConfirmButton from '../confirm-button';
import { denyEventMemberMutation } from '../../apollo/events';
import type { EventMember } from '../../types/EventMember';

type Props = {
  member?: EventMember;
};

const EventDenyMemberButton = ({ member }: Props) => {
  const [denyEventMember] = useMutation(denyEventMemberMutation);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  return (
    <ConfirmButton
      label="Deny"
      message="Deny Request"
      size="small"
      onClick={() => {
        setSubmitting(true);
        denyEventMember({
          variables: {
            id: member.id,
            message
          }
        }).then(() => {
          setSubmitting(false);
        }).catch(() => {
          alert('An error occurred while submitting. Please try again.');
          setSubmitting(false);
        });
      }}
      disabled={submitting}
    >
      <DialogContentText sx={{ mb: 1 }}>
        Deny {member.user.displayName}&lsquo;s request to join
      </DialogContentText>
      <MaterialTextField
        autoFocus
        id="message"
        label="Message to requester"
        fullWidth
        multiline
        rows={3}
        maxRows={20}
        variant="outlined"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
      />
    </ConfirmButton>
  );
};

export default EventDenyMemberButton;
